// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-min-width-eg1Na7:not(.semi-button-with-icon-only){min-width:96px}.button-yJDwte.button-size-small-hPxLPb{border-radius:6px}.button-yJDwte.button-size-small-hPxLPb .semi-button-content-right{margin-left:4px}.button-yJDwte.button-size-default-DktMns{border-radius:8px}.button-yJDwte.button-size-default-DktMns .semi-button-content-right{margin-left:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button-min-width": `button-min-width-eg1Na7`,
	"buttonMinWidth": `button-min-width-eg1Na7`,
	"button": `button-yJDwte`,
	"button-size-small": `button-size-small-hPxLPb`,
	"buttonSizeSmall": `button-size-small-hPxLPb`,
	"button-size-default": `button-size-default-DktMns`,
	"buttonSizeDefault": `button-size-default-DktMns`
};
export default ___CSS_LOADER_EXPORT___;
